export type * from './types';
import fetch from './fetch';
import * as error from './error';

const fetchAssign = Object.assign(fetch, error);
export { fetchAssign as fetch };
